var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEC722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19.1425C23.5 21.8725 21.8725 23.5 19.1425 23.5H18.25C17.8375 23.5 17.5 23.1625 17.5 22.75V18.4225C17.5 18.22 17.665 18.0475 17.8675 18.0475L19.1875 18.025C19.2925 18.0175 19.3825 17.9425 19.405 17.8375L19.6675 16.405C19.69 16.27 19.585 16.1425 19.4425 16.1425L17.845 16.165C17.635 16.165 17.47 16 17.4625 15.7975L17.4325 13.96C17.4325 13.84 17.53 13.735 17.6575 13.735L19.4575 13.705C19.585 13.705 19.6825 13.6075 19.6825 13.48L19.6525 11.68C19.6525 11.5525 19.555 11.455 19.4275 11.455L17.4025 11.485C16.1575 11.5075 15.1675 12.5275 15.19 13.7725L15.2275 15.835C15.235 16.045 15.07 16.21 14.86 16.2175L13.96 16.2325C13.8325 16.2325 13.735 16.33 13.735 16.4575L13.7575 17.8825C13.7575 18.01 13.855 18.1075 13.9825 18.1075L14.8825 18.0925C15.0925 18.0925 15.2575 18.2575 15.265 18.46L15.3325 22.735C15.34 23.155 15.0025 23.5 14.5825 23.5H12.8575C10.1275 23.5 8.5 21.8725 8.5 19.135V12.8575C8.5 10.1275 10.1275 8.5 12.8575 8.5H19.1425C21.8725 8.5 23.5 10.1275 23.5 12.8575V19.1425V19.1425Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.725e3ded8e9e4adafb27f8388ad2a3d4.svg";
export { ForwardRef as ReactComponent };